import { useTranslation } from "react-i18next";
import StayQuote from "@/model/StayQuote";
import { formatMoney } from "@/utils/pricing";
import "@/components/PriceBreakdown/PriceBreakdown.scss";

interface PriceBreakdownProps {
  quote: StayQuote;
}

function PriceBreakdown({ quote }: PriceBreakdownProps) {
  const { t, i18n } = useTranslation();
  const money = (amount: number) => formatMoney(amount, quote.currency, i18n.language);

  return (
    <dl className="price-breakdown">
      <div className="price-breakdown__row">
        <dt>
          {t("price.nights", {
            price: money(quote.nightlyPrice),
            count: quote.nights,
          })}
        </dt>
        <dd>{money(quote.lodgingTotal)}</dd>
      </div>

      {quote.cleaningFee > 0 && (
        <div className="price-breakdown__row">
          <dt>{t("price.cleaningFee")}</dt>
          <dd>{money(quote.cleaningFee)}</dd>
        </div>
      )}

      {quote.extras.map((line) => (
        <div key={line.extraId} className="price-breakdown__row">
          <dt>{line.name}</dt>
          <dd>{money(line.total)}</dd>
        </div>
      ))}

      <div className="price-breakdown__row price-breakdown__row--total">
        <dt>{t("price.total")}</dt>
        <dd>{money(quote.total)}</dd>
      </div>
    </dl>
  );
}

export default PriceBreakdown;
export type { PriceBreakdownProps };
